// extracted by mini-css-extract-plugin
export var carouselContentBasic = "CarouselSlide-module__carouselContentBasic--30Ln5";
export var carouselContentContainer = "CarouselSlide-module__carouselContentContainer--2lq0Y CarouselSlide-module__carouselContentBasic--30Ln5";
export var carouselContentContainerOneEl = "CarouselSlide-module__carouselContentContainerOneEl--EwAqI CarouselSlide-module__carouselContentBasic--30Ln5";
export var carouselSlideContainer = "CarouselSlide-module__carouselSlideContainer--iX8xn";
export var col = "CarouselSlide-module__col--3abgA";
export var icon = "CarouselSlide-module__icon--1qjTk";
export var iconWrapper = "CarouselSlide-module__iconWrapper--2DME6";
export var icons = "CarouselSlide-module__icons--4eyka";
export var linkLearnMore = "CarouselSlide-module__linkLearnMore--18ao4";
export var linkLearnMoreContainer = "CarouselSlide-module__linkLearnMoreContainer--2L75l";